let contracts = () => import('../app/Components/Views/Contracts/ContractDetails.vue'); // <- ruta donde estan los tabs

export default [
    // pestañas para la edicion del contrato
    {
        path: '/contracts/add/contract_details',
        component: contracts,    
        name: 'contract'
    },
    {
        path: '/contracts/add/product_details',
        component: contracts,    
        name: 'products'
    },
    {
        path: '/contracts/add/supplier_details',
        component: contracts,    
        name: 'supplier'
    },
    {
        path: '/contracts/add/customer_details',
        component: contracts,    
        name: 'customer'
    },
    {
        path: '/contracts/add/documents_details',
        component: contracts,    
        name: 'documents'
    },
    {
        path: '/contracts/add/revision_details',
        component: contracts,    
        name: 'revision'
    },
]